export default __webpack_public_path__ + "static/media/AWN.8e3182aa.png";